<template>
  <el-drawer
    title=""
    size="100%"
    :append-to-body="true"
    :with-header="false"
    :visible.sync="drawer"
    direction="rtl"
  >
    <div class="login">
      <i
        class="el-icon-close"
        @click="handleClose"
      />
      <h2>登录</h2>
      <h3>登录智能码，体验更多功能</h3>
      <div style="margin-top:60px;margin-bottom:30px;padding: 0 27px;">
        <label
          for=""
          class="label"
        >手机号</label>
        <van-field
          v-model="loginForm.username"
          label=""
          placeholder="请输入手机号"
        />
      </div>
      <div style="margin-bottom:20px;padding: 0 27px;">
        <label
          for=""
          class="label"
        >密码</label>
        <van-field
          v-model="loginForm.password"
          label=""
          placeholder="请输入密码"
          type="password"
        />
      </div>
      <van-row
        type="flex"
        justify="space-between"
        class="rowBtns"
      >
        <van-col
          span="6"
          class="register"
          @click="toRegister"
        >
          账号注册
        </van-col>
        <van-col
          span="6"
          style="position:relative;left:8px"
          class="forgotPassword"
          @click="forgotPassword"
        >
          忘记密码？
        </van-col>
      </van-row>
      <div style="text-align:center">
        <van-button
          class="loginBtn"
          type="info"
          size="large"
          @click="handleCaptcha"
          v-track="{triggerType: 'click',operType:'click','desc':'点击【登录】',page:'智能码-移动端-登录'}"
        >
          登录
        </van-button>
      </div>

      <!-- <div class="otherLogin">
      <p>第三方账号登录</p>
      <img :src="wxIcon" alt="" @click="wxLogin()">
    </div> -->
    </div>
    <Captacha
      ref="captacha"
      @submitCa="login($event)"
    />
    <Register />
  </el-drawer>
</template>

<script>
import eventBus from '@/utils/event-bus'
import Register from './register'
import { login } from '@/api/login'
import { Toast } from 'vant'
import Captacha from './captacha'
import { validatePassword } from "@/utils/password";

export default {
  name: 'Login',
  components: { Register, Captacha },
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      wxIcon: require('../../../static/icon_wx.png'),
      loginForm: {
        username: '',
        password: ''
      }
      // back: '1',
    }
  },
  mounted () {
    console.log('drawerdrawerdrawer', this.drawer)
    // let _this = this
    document.title = '智能码移动站 - 二维码生成器-免费二维码制作-在线二维码解决方案-在线二维码制作-二维码在线生成-二维码在线打印'
    // const token = localStorage.getItem("token")
    // this.back = this.$route.query.back ? this.$route.query.back : '1'
  },
  methods: {
    handleClose () {
      eventBus.$emit('closedLogin')
    },
    toRegister () {
      // this.$router.push('/register')
      eventBus.$emit('closedLogin')
      eventBus.$emit('openReg')
    },
    forgotPassword () {
      this.$message({
        type: 'warning',
        message: '此功能暂未开放'
      })
    },
    handleCaptcha () {
      this.$refs.captacha.openCaptcha()
    },
    login (param) {
      this.loginForm.captchaCode = param.captchaVal
      this.loginForm.uuid = param.uuid

      if (this.loginForm.username === '') {
        Toast.fail('请输入手机号')
        return
      }
      if (this.loginForm.password === '') {
        Toast.fail('请输入密码')
        return
      }

      const result = validatePassword(this.loginForm.password)
      if (result === '' || result.length === 0) {
      } else {
        Toast.fail('密码过于简单，请登录电脑端后台修改密码！')
        return
      }

      const r = login(this.loginForm.username, this.loginForm.password, this.loginForm.uuid, this.loginForm.captchaCode)

      r.then((res) => {
        if (res.code === 200) {
          localStorage.setItem('token', res.token)

          this.handleClose()
          eventBus.$emit('reload')
          // const roles = r.roles
          // if (roles.indexOf('admin') > -1 || roles.indexOf('operator') > -1) {
          //   Toast.success('登录成功,即将跳转...')
          //   setTimeout(function () {
          //     that.$router.push('/policy/manage/list', () => { }, () => { })
          //   }, 1000)
          // } else {
          // if (this.back === '1') {
          //   that.$router.go(-1)
          // } else if (this.back === '2') {
          //   that.$router.replace({ path: '/userInfo', replace: true, query: { 'back': '2' } })
          // }
          //
          // }
        } else {
          Toast.fail('登录失败')
        }
      })
    },
    wxLogin () {
      // let appid = 'wx922894588b56601e'
      // let redirect_uri = '/userInfo'
      // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATUS#wechat_redirect`
      this.$message({
        type: 'warning',
        message: '此功能暂未开放'
      })
    }
  }

}
</script>
<style lang="scss">
.el-drawer__header {
  margin-bottom: 0px !important;
}
</style>
<style scoped lang="scss">
.login {
  width: 100%;
  height: 100%;
  padding-top: 60px;
  background-image: url('../../../static/img_loginbg.png');
  // background: #2578E3;
  background-size: 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  position: relative;

  .el-icon-close {
    font-size: 25px;
    color: #fff;
    position: absolute;
    top: 20px;
    right: 20px
  }

  h2 {
    margin-top: 0;
    margin-left: 23px;
    padding: 0;
    font-size: 30px;
    font-weight: bold;
    color: #FFFFFF;
  }

  h3 {
    margin-top: 16px;
    margin-left: 23px;
    padding: 0;
    font-size: 20px;
    font-weight: bold;
    color: #FFFFFF;
  }

  .label {
    font-size: 18px;
    font-weight: bold;
    color: #081C35;
  }

  .loginBtn {
    margin-top: 31px;
    width: 320px;
    height: 44px;
    background: #2578E3;
    border-radius: 5px;
  }

  .van-cell {
    border-bottom: 1px solid #F0F0F0;
    padding: 16px 0;
  }

  .rowBtns {
    padding: 0 27px;
  }

  .register {
    font-weight: 500;
    font-size: 15px;
    color: #2578E3;
  }

  .forgotPassword {
    font-size: 15px;
    font-weight: 500;
    color: #9D9D9D;
  }

  .otherLogin {
    width: 100%;
    margin-top: 80px;
    padding-bottom: 40px;
    // position: absolute;
    // bottom: 30px;
    // left: 0;

    p {
      text-align: center;
      font-size: 11px;
      font-weight: 500;
      margin-bottom: 20px;
      color: #9D9D9D;
    }

    img {
      display: block;
      margin: 0 auto;
      width: 44px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue